var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,13.2c0-.4,0-.8,0-1.2H3v2h4.5c0-.3,0-.5,0-.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 12,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1,8H3v2h5.1c.3-.7.6-1.4,1.1-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,20c-1.1,0-2-.4-2.8-1.1-.8-.8-1.1-1.7-1.1-2.8v-.3c-.9-.1-1.6-.5-2.1-1.2s-.9-1.4-.9-2.3v-3.6h1.8v-.6h1.2v2.4h-1.2v-.6h-.6v2.4c0,.7.2,1.2.7,1.7.5.5,1,.7,1.7.7s1.2-.2,1.7-.7c.5-.5.7-1,.7-1.7v-2.4h-.6v.6h-1.2v-2.4h1.2v.6h1.8v3.6c0,.9-.3,1.7-.9,2.3s-1.3,1.1-2.1,1.2v.3c0,.8.3,1.4.8,1.9s1.2.8,1.9.8,1.4-.3,1.9-.8.8-1.2.8-1.9v-1c-.3-.1-.6-.3-.9-.6s-.3-.7-.3-1.1.2-.9.5-1.3.8-.5,1.3-.5.9.2,1.3.5.5.8.5,1.3-.1.7-.3,1.1-.5.5-.9.6v1c0,1.1-.4,2-1.1,2.8-.8.8-1.7,1.1-2.8,1.1ZM20.2,14c.2,0,.3,0,.4-.2s.2-.3.2-.4,0-.3-.2-.4-.3-.2-.4-.2-.3,0-.4.2-.2.3-.2.4,0,.3.2.4.3.2.4.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorList);
export default __webpack_public_path__ + "static/media/doctorList.6f84ffc2da07e7ae91cb457eb864bd12.svg";
export { ForwardRef as ReactComponent };